<template>
  <div class="issue-actions-table-cell">
    <div class='initiate-integration-section' :class='{ "disabled": openTicketDisabled }' v-if='!ticketExist'>
      <custom-tooltip class="initiate-integration-tooltip" popper-class="light-tooltip" :disabled='openTicketDisabled'>
        <div slot='buttonContent'>
          <new-ticket :class='{ "disabled": openTicketDisabled }' @click.stop='integrationClicked'/>
        </div>
        <div slot="content">
          <slot name="tooltip">
            <span> {{ $t('technologies.jira.integration.button.hover.text') }} </span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
    <div class='exist-integration-section' v-else>
      <custom-tooltip class="exist-integration-tooltip" popper-class="light-tooltip">
        <div slot='buttonContent'>
          <ticket @click.stop="goToTicketUrl" class='exist-ticket-integration'/>
        </div>
        <div slot="content">
          <slot name="tooltip">
            <span> {{ $t('ticketing.integration.go.to.ticket.button.hover.text') }} </span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
  </div>
</template>

<script>

import NewTicket from '@/assets/icons/New_Ticket.svg?inline';
import Ticket from '@/assets/icons/ticket.svg?inline';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'IssueActionsTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  components: {
    NewTicket,
    Ticket,
    CustomTooltip,
  },
  computed: {
    issueUrl() {
      return this.item.metaData.integrationData?.Ticketing?.open_ticket?.url || '';
    },
    openTicketDisabled() {
      return (this.item.metaData.integrationData?.Ticketing?.open_ticket &&
        this.item.metaData.integrationData?.Ticketing?.open_ticket === 'pending') || false;
    },
    ticketExist() {
      return this.item.metaData.integrationData?.Ticketing?.open_ticket?.id || false;
    },
  },
  methods: {
    goToTicketUrl() {
      window.open(
        this.issueUrl,
        '_blank',
      );
    },
    async integrationClicked() {
      if (!this.openTicketDisabled) {
        this.$emit('integrationClicked', this.item);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

@import '~@/assets/styles/design-system';

.issue-actions-table-cell {
  align-items: center;
  justify-content: center;
  position: absolute;
  display: flex;
  .exist-integration-section {
    margin-left: rem(10);
    z-index: 3;
    align-items: center;
    display: flex;
    justify-content: center;
    .exist-integration-tooltip {
      min-width: rem(24);
      min-height: rem(24);
      background-color: transparent;
    }
    .exist-ticket-integration {
      fill: var(--status-success);
      user-select: none;
      transform: rotate(180deg);
      &:focus {
        outline: none;
      }
    }
    svg {
      outline: none;
      &:focus, &:active {
        outline: none;
      }
    }
    &:hover {
      cursor: pointer;
    }
    &:active{
      background-color: var(--status-success-bg) !important;
    }
  }
    .initiate-integration-section {
    margin-left: rem(10);
    z-index: 3;
    align-items: center;
    display: var(--displayactioncell) !important;
    justify-content: center;
    min-width: rem(32);
    min-height: rem(32);
    background-color: var(--status-success-bg);
    border-radius: $radius-md;
    box-shadow: 0 0 rem(1) 0 rgba(0,0,0,0.14), 0 0 rem(1) 0 rgba(0,0,0,0.14);
      .initiate-integration-tooltip {
        min-width: rem(24);
        min-height: rem(24);
        background-color: transparent;
        fill: var(--status-success);
      }
    .new-ticket-integration {
      user-select: none;
      &:focus {
        outline: none;
      }
    }
    svg {
      outline: none;
      &:focus, &:active {
        outline: none;
      }
    }
    :not(.disabled) {
      &:hover {
        cursor: pointer;
      }
      &:active{
        background-color: var(--status-success-bg) !important;
      }
    }
    &.disabled {
      opacity: 0.5;
      cursor: default;
      background-color: transparent;
    }
  }
}
</style>
